<p-popover
  appPopoverArrow
  #panel
  appendTo="body"
  styleClass="insurance-popover"
  [dismissable]="true"
>
  @if (insurance) {
    <div class="formula-row">
      <span class="formula-term">
        <span class="formula-op">(</span>
        <input
          pInputText
          class="form-control cargo-value"
          type="number"
          placeholder="Cargo value"
          [disabled]="disabled()"
          [(ngModel)]="insurance.insuranceCargoValue"
          (change)="insuranceSubject.next(insurance)"
        />
      </span>
      <span class="formula-op">+</span>
      <span class="formula-term">
        <input
          pInputText
          class="form-control"
          type="number"
          placeholder="Freight"
          [disabled]="disabled()"
          [(ngModel)]="insurance.insuranceFreightValue"
          (change)="insuranceSubject.next(insurance)"
        />
        <span class="formula-op">)</span>
      </span>
      <span class="formula-op">*</span>
      <span class="formula-term">
        <input
          pInputText
          class="form-control"
          placeholder="Multiplier"
          type="number"
          [disabled]="true"
          [(ngModel)]="insurance.insuranceValueMultiplierPercent"
          (change)="insuranceSubject.next(insurance)"
        />
        <span class="formula-op">%</span>
      </span>
      <span class="formula-op">*</span>
      <span class="formula-term">
        <input
          pInputText
          class="form-control"
          type="number"
          placeholder="Rate"
          [disabled]="disabled()"
          [(ngModel)]="insurance.insuranceRatePercent"
          (change)="insuranceSubject.next(insurance)"
        />
        <span class="formula-op">%</span>
      </span>
      <p-select
        [(ngModel)]="insurance.insuranceCurrency"
        (onChange)="insuranceSubject.next(insurance)"
        [disabled]="disabled()"
        [options]="currencySelectList"
        [filter]="true"
        filterBy="label, value"
      >
      </p-select>
      <button
        pButton
        class="apply-button"
        aria-label="Apply insurance"
        (click)="applyInsurance(panel)"
      >
        <i class="pi pi-check" aria-hidden="true"></i>
      </button>
    </div>
    <p-chip
      [label]="insuranceLabel()"
      [removable]="!disabled()"
      removeIcon="pi pi-times"
      (onRemove)="removeInsurance(panel)"
    />
  }
</p-popover>

@if (isHeaderVariant()) {
  <button
    pButton
    type="button"
    severity="success"
    class="insurance-btn"
    [text]="!isInsured()"
    [disabled]="disabled()"
    [attr.aria-pressed]="isInsured()"
    [pTooltip]="
      isInsured() ? 'Insurance: ' + insuranceLabel() : 'Add insurance'
    "
    tooltipPosition="top"
    aria-label="Insurance"
    (click)="togglePanel($event, panel)"
    data-cy="quote-insurance"
  >
    @if (isInsured()) {
      <svg
        class="insured-icon"
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M15.127 2.19495C15.362 1.9878 15.7158 1.96138 15.9805 2.11682L16.0879 2.19495L16.125 2.23596C16.1355 2.2505 16.1442 2.2663 16.1514 2.28284L16.1524 2.28382L16.1534 2.28577C16.1534 2.28577 16.1544 2.28945 16.1553 2.29163C16.1571 2.29597 16.1593 2.30203 16.1621 2.30921C16.1678 2.32357 16.1755 2.34372 16.1836 2.3678C16.1997 2.4154 16.2197 2.48278 16.2334 2.55823C16.2468 2.63198 16.2563 2.72551 16.2432 2.82093C16.23 2.91718 16.1905 3.03494 16.0879 3.12561L8.56547 9.77014C8.29695 10.0069 7.87304 10.0069 7.60453 9.77014L4.63285 7.14807C4.34641 6.895 4.34627 6.47041 4.63285 6.21741C4.90132 5.98055 5.32522 5.98071 5.59379 6.21741L8.08403 8.41468L15.127 2.19495Z"
          fill="currentColor"
        />
        <path
          d="M7.72116 0.0604958C7.9009 -0.0206826 8.10696 -0.019969 8.28659 0.0614723C9.79691 0.746252 10.8551 1.17425 11.9965 1.51264L10.7514 2.55366C9.91785 2.26595 9.06307 1.91306 8.00338 1.43745C5.47117 2.56987 4.10385 3.01635 1.37741 3.52925C1.26589 7.53466 2.80006 10.2309 4.44088 11.9716C5.87318 13.491 7.39637 14.2905 8.00045 14.5673C8.92042 14.1414 11.8555 12.5646 13.4965 9.15425L14.5424 10.1455C12.4109 14.1886 8.66277 15.7862 8.26217 15.9492C8.10112 16.0147 7.92064 16.0172 7.75827 15.955C7.42515 15.8273 5.36045 14.9472 3.44284 12.913C1.50776 10.8602 -0.264128 7.64189 0.0326793 2.91011C0.0524451 2.59511 0.284619 2.33434 0.595179 2.27827C3.68307 1.7217 4.93682 1.318 7.72116 0.0604958Z"
          fill="currentColor"
        />
      </svg>
    } @else {
      <svg
        class="uninsured-icon"
        width="16"
        height="16"
        viewBox="0.5 0.5 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.21784 0.560774C8.3975 0.479598 8.60339 0.479749 8.78293 0.561188C11.5738 1.82714 12.8172 2.22154 15.9047 2.77828C16.2152 2.83427 16.4474 3.0951 16.4672 3.41014C17.064 12.9167 9.34017 16.2126 8.75817 16.4495C8.59705 16.515 8.41703 16.5169 8.25461 16.4546C7.92163 16.3269 5.85833 15.447 3.94154 13.4126C2.00731 11.3598 0.235908 8.14207 0.5327 3.41018C0.55246 3.09513 0.784646 2.83428 1.09516 2.77828C4.18169 2.22171 5.43465 1.81833 8.21784 0.560774ZM1.87654 4.02889C1.76485 8.03484 3.29871 10.7311 4.93896 12.4719C6.37072 13.9915 7.89311 14.7904 8.49688 15.0673C9.82108 14.4539 15.328 11.4572 15.1232 4.02895C12.3993 3.51702 11.0397 3.07839 8.4994 1.93775C5.96826 3.0702 4.60189 3.51599 1.87654 4.02889Z"
          fill="currentColor"
        />
      </svg>
    }
  </button>
} @else {
  <span #trigger class="layout-option">
    <p-checkbox
      [binary]="true"
      [disabled]="disabled()"
      [ngModel]="isInsured()"
      (onChange)="
        onShowInsuranceChange(
          $event.checked,
          $event.originalEvent,
          panel,
          trigger
        )
      "
      [inputId]="checkboxId()"
    >
    </p-checkbox>
    <button
      type="button"
      class="layout-option__text"
      (click)="togglePanel($event, panel, trigger)"
    >
      Add insurance
    </button>
  </span>
}
